import { cn } from "tools/ui";

const base = "grid gap-x-2 mb-auto rounded-lg h-full";

function GridForm(props) {
  const { widget, children } = props;
  let border = "";
  const rows = "";
  let style = "grid gap-x-2 mb-auto rounded-lg h-full";
  if (props.style) {
    style = props.style;
  }
  const colspan = widget.colSpan ?? "md:col-span-2 lg:col-span-2 xl:col-span-2";
  const cols = widget.cols ?? `grid-cols-${widget.elements.length}`;
  if (widget.border === "visible") {
    border = "border border-dashed border-neutral-400 px-2";
  }

  return (
    <div
      id={`gridform-${widget.name}`}
      key={widget.name}
      className={cn(style, colspan, cols, rows, border)}
    >
      {children}
    </div>
  );
}

export default GridForm;
